import { z } from "zod";
import { emailAdressValidator } from "../../../Utils/stringUtls";

/**
 * Validation schema for input form.
 */
export const validationSchema = z
  .object({
    name: z.string().min(1, { message: "Name is required" }),
    email: z
      .string()
      .min(1, { message: "Email address is required" })
      .refine((val) => emailAdressValidator(val), "Invalid Email address"),
    password: z
      .string()
      .min(13, { message: "Password is required, Min length 13 Characters" })
      .refine(
        (password) => {
          // Add your custom password validation logic here
          // Return true if validation passes, false otherwise
          return (
            /[A-Z]/.test(password) && // At least one uppercase letter
            /[0-9]/.test(password) && // At least one digit
            /[@$!%*?&\\/]/.test(password) && // At least one special character
            /^.{13,}$/.test(password)
          );
        },
        { message: "Invalid password format" },
      ),
    password_confirmation: z.string().min(13, { message: "Invalid format." }),
    designation: z.string().min(1, { message: "Designation is required" }),
    contact: z.string().min(1, { message: "Contact number is required" }),
    country_code: z.string(),
    company: z.string().min(1, { message: "Company Name is required" }),
  
    role_id: z.number(1, { message: "Role is required" }),
    is_active: z.boolean("value must be True|False"),
    avatar: z.string().optional(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords don't match",
    path: ["password_confirmation"],
  });

/**
 * Validation schema for updating user data.
 */
export const updateValidationSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  email: z
    .string()
    .min(1, { message: "Email address is required" })
    .refine((val) => emailAdressValidator(val), "Invalid Email address"),
  designation: z.string().min(1, { message: "Designation is required" }),
  contact: z.string().min(1, { message: "Contact number is required" }),
  country_code: z.string(),
  company: z.string().min(1, { message: "Company Name is required" }),
   
  role_id: z.number(1, { message: "Role is required" }),
  is_active: z.boolean("value must be True|False"),
  avatar: z.string().optional(),
});
